import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import GoModal from '@/core/go-modal/go-modal.vue';
import { AccountResponseDto } from '@/shared/model/scrap-agent.model';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';

@Component({
  components: {
    'go-modal': GoModal,
    'go-loading': ListLoading,
  },
})
export default class ChannelAccountModal extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Boolean, default: false }) loading: boolean;
  @Prop({ type: Array, default: [] }) readonly accounts: AccountResponseDto[];
  @Prop({ type: String }) readonly channelType: string;
  @Prop({ type: String }) readonly channelName: string;
  @Prop({ type: String }) readonly channelImageUri: string;

  @Emit('modal:close') close() {}

  @Emit('modal:ok') ok(payload: any) {}

  @Emit('channel:register') register(payload: any) {}
}
